module.exports = __webpack_public_path__ + "static/media/optic_logo.d36921a8.svg";